<app-bunch-tables (sendIdBunch)="getSubIdparent($event)" (sendIsClick)="getIsClick($event)"
                  (showModal)="getShowModal($event)" (removeModal)="getRemoveId($event)"
                  (editModal)="getEditModal($event)" [style]="getItemStyle(bunch)"
                  [disableClickBunch]="disableClickBunch" class="bunch-table-item"
                  *ngFor="let bunch of listBunch" [bunch]="bunch"></app-bunch-tables>
